import SearchNavGroupDialog from './SearchNavGroupDialog.client';

export default function SearchNavGroup() {
  return (
    <SearchNavGroupDialog />
  );
}